import { copyFormSelectValues, disableReviewSelects } from "#/shared/legacy/forms/form-preview.js";

class FormReview {
  constructor(options) {
    this.options = jQuery.extend({}, options);
    this.el = jQuery(`<div class='form-review'></div>`);
  }

  // HELPERS

  addReviewItem(formFields) {
    const previewBody = this.cloneFormFields(formFields);

    this.el.append(previewBody);
    this._disableInputs();
  }

  cloneFormFields(formFields) {
    formFields.find(":input").each(function () {
      jQuery(this).attr("stored-value", jQuery(this).val());
    });

    var previewBody = formFields.clone();
    previewBody.find(":input").each(function () {
      jQuery(this).val(jQuery(this).attr("stored-value"));
    });

    copyFormSelectValues(formFields, previewBody);

    return previewBody;
  }

  // PRIVATE

  _disableInputs() {
    disableReviewSelects(this.el[0]);

    this.el.find(":input").each(function () {
      jQuery(this).attr("disabled", true);

      // Hide input container to prevent spacing issues in preview modal
      if (jQuery(this).is(":required") && jQuery(this).val() == "") {
        jQuery(this).parent().hide();
      }
    });
  }
}

window.FormReview = FormReview;
